import { ReactElement } from 'react'
import UserList from '../../components/Driver'
import Layout from '../../components/layout'

const DriversPage = (): ReactElement => {
  return (
    <Layout>
      <UserList />
    </Layout>
  )
}

export default DriversPage
